export const notificationApiSupport =
  'Notification' in window && 'serviceWorker' in navigator && 'PushManager' in window

export const requestPermission = async (): Promise<boolean> => {
  const result = await Notification.requestPermission()
  return result === 'granted'
}

export const sendNotification = (title: string, body: string) => {
  if (!notificationApiSupport) return
  if (Notification.permission !== 'granted') return
  const options = { body, icon: '/arkade-icon.svg' }
  try {
    new Notification(title, options)
  } catch {
    navigator.serviceWorker.ready.then((registration) => registration.showNotification(title, options)).catch(() => {})
  }
}

export const sendTestNotification = () => {
  const body = 'If you read this, everything is ok'
  const title = 'Test notification'
  sendNotification(title, body)
}
